<template>
  <div id="spinnerWrapper">
    <Spinner></Spinner>
  </div>
</template>

<script>

  import Spinner from "./Spinner.vue"

	export default {
		name: "SpinnerOverlay",
    components: {Spinner},
	}
</script>

<style lang="less" scoped>

  @import "../../assets/less/palette.less";

  #spinnerWrapper {
     width: 100%;
    height: 100%;
    display: flex;
     align-content: center;
    align-items: center;
    justify-content: center;
    background: rgba(@white, .6);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
  }

</style>
